import { User, UserRole } from '@domain/users/types'

export const initialUser: User = {
  email: '',
  emailVerified: false,
  role: UserRole.User,
  uuid: '',
  avatar: '',
  name: '',
  rewardsState: {
    completedProjects: [],
    quests: {
      activeQuests: 0,
      completedQuests: 0,
      inactiveQuests: 0,
      totalQuests: 0,
      verifiedQuests: 0,
    },
    userMissions: [],
    wlthSummary: {},
    xpSummary: {
      currentXp: 0,
      lifetimeXp: 0,
      redeemedXp: 0,
    },
  },
  socials: {},
}
